import { Button, Modal } from 'antd';
import React, { useState } from 'react';

export default function ModalChangePlan({ visible, modalitie, onClose, onOk }) {

    const _onCancel = () => {
        onClose();
    };

    return (
        <>
            <Modal
                title="Cambio de Coberturas"
                visible={visible}
                onCancel={_onCancel}
                cancelText='Cancelar'
                okText='Cambiar'
                onOk={()=>onOk(modalitie.modalityId)}
                closable={false}
                wrapClassName='modal-change'
                zIndex={100001}
            >
                <div>
                    <p>Para contratar este beneficio</p>
                    <strong>{modalitie.coverageName}</strong>
                    <p>se debe cambiar de cobertura</p>
                    <div>¿Desea cambiar a cobertura {modalitie.modality}?</div>
                </div>
            </Modal>
        </>
    );
};